import React, { FC, ReactElement } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { SessionPoller } from './SessionPoller'
import { RonSessionLauncherProps } from './types'

const queryClient = new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: false, retry: false } } })

const RonSessionLauncher: FC<RonSessionLauncherProps> = (props): ReactElement => (
  <QueryClientProvider client={queryClient}>
    <SessionPoller {...props} />
  </QueryClientProvider>
)

export default RonSessionLauncher
